// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__236z2","cell":"ColumnAccessor_cell__1_ZG0","firstCellAccent":"ColumnAccessor_firstCellAccent__jT88G"};